/* ============================================================================
FILE: po-rezonans-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la collection « RéZonans ».
ROOT: [data-po-rezonans-collection]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIENS: RéZonans, Piliers, Posœnnoïsme, Multiple-pluriel.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_REZONANS_COLLECTION_20260727__) return;
  window.__PO_REZONANS_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-rezonans-collection]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var CANONICAL_LINKS = {
    rezonans: "https://goodyart.store/pages/rezonans",
    piliers: "https://goodyart.store/pages/piliers",
    posoennoisme: "https://goodyart.store/pages/posoennoisme",
    multiplePluriel: "https://goodyart.store/pages/multiple-pluriel"
  };

  function pageLink(value, href, isCanonical){
    var classes = "po-rezonans-collection__link";

    if (isCanonical) {
      classes += " po-rezonans-collection__canonical notranslate";
    }

    return '<a class="' + classes + '"' +
      (isCanonical ? ' translate="no"' : "") +
      ' href="' + escapeHTML(href) + '">' +
      escapeHTML(value) +
      "</a>";
  }

  function canonical(value, href){
    if (href) return pageLink(value, href, true);

    return '<span class="po-rezonans-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    rezonans: canonical("RéZonans", CANONICAL_LINKS.rezonans),
    posoennoisme: canonical("Posœnnoïsme", CANONICAL_LINKS.posoennoisme),
    multiplePluriel: canonical(
      "Multiple-pluriel",
      CANONICAL_LINKS.multiplePluriel
    ),
    piliersFr: pageLink("Piliers", CANONICAL_LINKS.piliers, false),
    piliersEn: pageLink("Pillars", CANONICAL_LINKS.piliers, false),
    piliersEs: pageLink("Pilares", CANONICAL_LINKS.piliers, false),
    onZouti: canonical("on zouti"),
    guadeloupe: canonical("Guadeloupe")
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        summary: "Description",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Description de la collection RéZonans"
      },
      paragraphs: [
        "En mai 2019, " + CANON.rezonans + " prend forme dans la préparation d’une exposition pensée comme un espace de rencontre entre les œuvres, les pratiques artistiques, les mémoires et les publics. Ce qui apparaissait alors comme le titre d’un événement culturel constituait déjà le point d’émergence visible d’une pensée plus vaste, portée depuis longtemps par mon travail et devenue aujourd’hui l’un des " + CANON.piliersFr + " du " + CANON.posoennoisme + ".",

        "Nos mots énoncés retentissent dans les souvenirs du temps et font surgir les événements de nos histoires. Tels des échos dans l’Autre, nos maux se prolongent, nos énergies prennent sens, se répondent et s’interprètent, jusqu’à produire une connaissance éprouvée dans les ressentis de chacun. La parole, la mémoire, la blessure, le silence et la relation deviennent alors les différentes intensités d’un même champ de rencontre.",

        CANON.rezonans + " exprime une acceptation active de nos histoires afin d’ouvrir la construction de notre avenir. Elle demeure ce «&nbsp;zeste d’expression du multiple&nbsp;», ce «&nbsp;zèle de l’esprit dans l’expression du pluriel&nbsp;» et cet «&nbsp;" + CANON.onZouti + "&nbsp;» par lequel la concertation, l’écoute et le respect des différences peuvent devenir les matières vivantes d’une cohésion. Chaque singularité y conserve son poids, sa place, son histoire et sa manière propre d’entrer en relation avec l’ensemble.",

        "Dans cette collection, les détails agissent comme des seuils du discours général. Ce qui paraît secondaire, discret, fragmentaire ou presque insignifiant peut porter la clef d’une lecture plus ample. Chaque élément participe à la construction de l’œuvre comme chaque expérience, chaque mémoire et chaque voix participent à la construction d’un projet commun. Le détail cesse alors d’être périphérique&nbsp;: il devient une présence active, capable d’orienter le regard, de déplacer le sens et de révéler l’organisation profonde de l’ensemble.",

        CANON.rezonans + " écoute ainsi les différences dans la mesure de leur intensité, de leur place et de ce qu’elles racontent de nous. Elle met en relation l’individu avec ses histoires, son environnement, ses perceptions et les autres, dans un mouvement d’ajustement vivant où l’écart devient possibilité d’écoute, la distance devient passage et la pluralité devient une manière d’habiter ensemble le " + CANON.multiplePluriel + "."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        summary: "Description",
        audio: "Listen",
        stop: "Stop",
        content: "Description of the RéZonans collection"
      },
      paragraphs: [
        "In May 2019, " + CANON.rezonans + " took shape during the preparation of an exhibition conceived as a meeting space for works, artistic practices, memories and audiences. What appeared at the time as the title of a cultural event was already the visible point of emergence of a broader thought, long carried by my work and now one of the " + CANON.piliersEn + " of the " + CANON.posoennoisme + ".",

        "The words we utter reverberate through the memories of time and bring forth the events of our histories. Like echoes within the Other, our wounds extend, our energies take on meaning, answer one another and are interpreted, until they produce knowledge tested through each person’s feelings. Speech, memory, hurt, silence and relation then become the different intensities of a single field of encounter.",

        CANON.rezonans + " expresses an active acceptance of our histories in order to open the construction of our future. It remains this “zest of expression of the multiple”, this “zeal of the spirit in the expression of the plural”, and this “" + CANON.onZouti + "” through which dialogue, listening and respect for differences can become the living materials of cohesion. Each singularity retains its weight, its place, its history and its own way of entering into relation with the whole.",

        "In this collection, details act as thresholds of the general discourse. What seems secondary, discreet, fragmentary or almost insignificant may hold the key to a broader reading. Each element participates in the construction of the work, just as each experience, each memory and each voice participates in the construction of a shared project. The detail then ceases to be peripheral: it becomes an active presence capable of directing the gaze, shifting meaning and revealing the deep organisation of the whole.",

        CANON.rezonans + " thus listens to differences according to their intensity, their place and what they tell about us. It brings the individual into relation with their histories, environment, perceptions and others, within a living movement of adjustment in which difference becomes a possibility for listening, distance becomes passage, and plurality becomes a way of inhabiting the " + CANON.multiplePluriel + " together."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        summary: "Descripción",
        audio: "Escuchar",
        stop: "Detener",
        content: "Descripción de la colección RéZonans"
      },
      paragraphs: [
        "En mayo de 2019, " + CANON.rezonans + " toma forma durante la preparación de una exposición concebida como un espacio de encuentro entre las obras, las prácticas artísticas, las memorias y los públicos. Lo que entonces aparecía como el título de un acontecimiento cultural constituía ya el punto visible de emergencia de un pensamiento más amplio, presente desde hacía mucho tiempo en mi trabajo y convertido hoy en uno de los " + CANON.piliersEs + " del " + CANON.posoennoisme + ".",

        "Las palabras que enunciamos resuenan en los recuerdos del tiempo y hacen surgir los acontecimientos de nuestras historias. Como ecos en el Otro, nuestros males se prolongan, nuestras energías cobran sentido, se responden y se interpretan, hasta producir un conocimiento experimentado en los sentires de cada persona. La palabra, la memoria, la herida, el silencio y la relación se convierten entonces en las distintas intensidades de un mismo campo de encuentro.",

        CANON.rezonans + " expresa una aceptación activa de nuestras historias para abrir la construcción de nuestro porvenir. Sigue siendo ese «&nbsp;toque de expresión de lo múltiple&nbsp;», ese «&nbsp;celo del espíritu en la expresión de lo plural&nbsp;» y ese «&nbsp;" + CANON.onZouti + "&nbsp;» mediante el cual la concertación, la escucha y el respeto de las diferencias pueden convertirse en materias vivas de una cohesión. Cada singularidad conserva su peso, su lugar, su historia y su manera propia de entrar en relación con el conjunto.",

        "En esta colección, los detalles actúan como umbrales del discurso general. Lo que parece secundario, discreto, fragmentario o casi insignificante puede contener la clave de una lectura más amplia. Cada elemento participa en la construcción de la obra, del mismo modo que cada experiencia, cada memoria y cada voz participan en la construcción de un proyecto común. El detalle deja entonces de ser periférico: se convierte en una presencia activa, capaz de orientar la mirada, desplazar el sentido y revelar la organización profunda del conjunto.",

        CANON.rezonans + " escucha así las diferencias según su intensidad, su lugar y aquello que cuentan de nosotros. Pone en relación al individuo con sus historias, su entorno, sus percepciones y los demás, dentro de un movimiento de ajuste vivo en el que la diferencia se convierte en posibilidad de escucha, la distancia se vuelve paso y la pluralidad se transforma en una manera de habitar juntos el " + CANON.multiplePluriel + "."
      ]
    }
  };

  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-rezonans-collection__paragraph">' +
        paragraph +
        "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var summaryLabel = root.querySelector("[data-po-summary-label]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (summaryLabel) summaryLabel.textContent = data.ui.summary;
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-rezonans-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-rezonans-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") {
      return null;
    }

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(
      AUDIO_STATE.chunks[AUDIO_STATE.index]
    );
    voice = voiceFor(lang);

    utterance.lang = lang === "en"
      ? "en-US"
      : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-rezonans-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoRezonansCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
